module.exports = __webpack_public_path__ + "img/mooby.836567f1.png";